export default __webpack_public_path__ + "static/media/84.b74171e6.png";